// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addfinalprice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.addfinalprice-modal {
  background-color: #fff;
  width: 90%;
  max-width: 500px;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  position: relative;
}

.addfinalprice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.addfinalprice-header p {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.addfinalprice-close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #888;
}

.addfinalprice-close-btn:hover {
  color: #e74c3c;
}

.addfinalprice-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.addfinalprice-group {
  display: flex;
  flex-direction: column;
}

.addfinalprice-group label {
  font-weight: 500;
  margin-bottom: 0.4rem;
}

.addfinalprice-group input {
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
}

.addfinalprice-group input:focus {
  border-color: #007bff;
  outline: none;
}

.addfinalprice-submit-btn {
  margin-top: 1rem;
  background-color: #007bff;
  color: white;
  font-size: 1rem;
  padding: 0.75rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.addfinalprice-submit-btn:hover {
  background-color: #0056b3;
}

.final_pricing_container {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
  gap: 8px;
  flex-wrap: wrap;
}
.final_pricing_container button {
  background-color: #007bff;
  color: white;
  font-size: 1rem;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.final_pricing_container button:hover {
  background-color: #034081;
  transform: translateY(-2px);
}

.final_pricing_container button:active {
  transform: scale(0.97);
}

/* Responsive Styling */
@media screen and (max-width: 480px) {
  .final_pricing_container button {
    width: 100%;
    font-size: 1rem;
  }
}

.pricingdetalcard-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1rem;
  justify-content: center;
}

.pricingdetalcard {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 90%;
  width: 100%;
  transition: transform 0.3s ease;
}

.pricingdetalcard:hover {
  transform: translateY(-5px);
}

.pricingdetalcard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.pricingdetalcard-header h2 {
  font-size: 1.5rem;
  color: #333;
}

.pricingdetalcard-tag {
  background-color: #007bff;
  color: white;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
}

.pricingdetalcard-section {
  margin-bottom: 1.5rem;
}

.pricingdetalcard-section h4 {
  margin-bottom: 0.75rem;
  color: #444;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0.4rem;
}

.pricingdetalcard-grid,
.pricingdetalcard-cost-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem 1.5rem;
}

.pricingdetalcard-final {
  background-color: #f5f5f5;
  border-radius: 0.5rem;
  padding: 1rem;
}

.pricingdetalcard-no-data {
  text-align: center;
  font-size: 1.2rem;
  color: #999;
  margin-top: 2rem;
}

@media screen and (max-width: 768px) {
  .pricingdetalcard {
    padding: 1.5rem;
  }

  .pricingdetalcard-grid,
  .pricingdetalcard-cost-grid {
    grid-template-columns: 1fr;
  }

  .pricingdetalcard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .pricingdetalcard-header h2 {
    font-size: 1.3rem;
  }
}

@media screen and (max-width: 480px) {
  .pricingdetalcard-container {
    padding: 0.5rem;
  }

  .pricingdetalcard {
    padding: 1rem;
  }

  .pricingdetalcard-tag {
    font-size: 0.75rem;
    padding: 0.3rem 0.6rem;
  }
}

/* card */
/* Overlay */
.finalpricecard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  box-sizing: border-box;
}

/* Card Container */
.finalpricecard-detail {
  background: #fff;
  padding: 2rem;
  border-radius: 1rem;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: fadeIn 0.3s ease-in-out;
}

/* Title */
.finalpricecard-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #333;
}

/* Info Section */
.finalpricecard-info > div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  font-size: 1rem;
  color: #555;
}

/* Close Button */
.finalpricecard-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #888;
  transition: color 0.2s;
}
.finalpricecard-close-btn:hover {
  color: #f00;
}

/* Buttons */
.finalpricecard-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}
.updatefinalPriceCard,
.sendtosalesPricingDetail {
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  flex: 1 1;
  margin: 0 0.5rem;
  transition: background 0.3s ease;
}
.updatefinalPriceCard {
  background-color: #007bff;
  color: white;
}
.updatefinalPriceCard:hover {
  background-color: #0056b3;
}
.sendtosalesPricingDetail {
  background-color: #28a745;
  color: white;
}
.sendtosalesPricingDetail:hover {
  background-color: #1e7e34;
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive */
@media screen and (max-width: 600px) {
  .finalpricecard-detail {
    padding: 1.5rem;
  }

  .finalpricecard-title {
    font-size: 1.3rem;
  }

  .finalpricecard-info > div {
    flex-direction: column;
    align-items: flex-start;
  }

  .finalpricecard-buttons {
    flex-direction: column;
  }

  .updatefinalPriceCard,
  .sendtosalesPricingDetail {
    margin: 0.5rem 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pricing/pricingdetail.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2DAA2D;EAC3D,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,cAAc;EACd,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA,SAAS;AACT,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":[".addfinalprice-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n}\n\n.addfinalprice-modal {\n  background-color: #fff;\n  width: 90%;\n  max-width: 500px;\n  padding: 2rem;\n  border-radius: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.addfinalprice-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.addfinalprice-header p {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.addfinalprice-close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #888;\n}\n\n.addfinalprice-close-btn:hover {\n  color: #e74c3c;\n}\n\n.addfinalprice-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.addfinalprice-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.addfinalprice-group label {\n  font-weight: 500;\n  margin-bottom: 0.4rem;\n}\n\n.addfinalprice-group input {\n  padding: 0.7rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 1rem;\n}\n\n.addfinalprice-group input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.addfinalprice-submit-btn {\n  margin-top: 1rem;\n  background-color: #007bff;\n  color: white;\n  font-size: 1rem;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.addfinalprice-submit-btn:hover {\n  background-color: #0056b3;\n}\n\n.final_pricing_container {\n  display: flex;\n  justify-content: center;\n  margin: 2rem 0;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.final_pricing_container button {\n  background-color: #007bff;\n  color: white;\n  font-size: 1rem;\n  padding: 0.75rem 2rem;\n  border: none;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.final_pricing_container button:hover {\n  background-color: #034081;\n  transform: translateY(-2px);\n}\n\n.final_pricing_container button:active {\n  transform: scale(0.97);\n}\n\n/* Responsive Styling */\n@media screen and (max-width: 480px) {\n  .final_pricing_container button {\n    width: 100%;\n    font-size: 1rem;\n  }\n}\n\n.pricingdetalcard-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  padding: 1rem;\n  justify-content: center;\n}\n\n.pricingdetalcard {\n  background: #fff;\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  max-width: 90%;\n  width: 100%;\n  transition: transform 0.3s ease;\n}\n\n.pricingdetalcard:hover {\n  transform: translateY(-5px);\n}\n\n.pricingdetalcard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.pricingdetalcard-header h2 {\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.pricingdetalcard-tag {\n  background-color: #007bff;\n  color: white;\n  padding: 0.4rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n}\n\n.pricingdetalcard-section {\n  margin-bottom: 1.5rem;\n}\n\n.pricingdetalcard-section h4 {\n  margin-bottom: 0.75rem;\n  color: #444;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 0.4rem;\n}\n\n.pricingdetalcard-grid,\n.pricingdetalcard-cost-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem 1.5rem;\n}\n\n.pricingdetalcard-final {\n  background-color: #f5f5f5;\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n\n.pricingdetalcard-no-data {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #999;\n  margin-top: 2rem;\n}\n\n@media screen and (max-width: 768px) {\n  .pricingdetalcard {\n    padding: 1.5rem;\n  }\n\n  .pricingdetalcard-grid,\n  .pricingdetalcard-cost-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pricingdetalcard-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .pricingdetalcard-header h2 {\n    font-size: 1.3rem;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .pricingdetalcard-container {\n    padding: 0.5rem;\n  }\n\n  .pricingdetalcard {\n    padding: 1rem;\n  }\n\n  .pricingdetalcard-tag {\n    font-size: 0.75rem;\n    padding: 0.3rem 0.6rem;\n  }\n}\n\n/* card */\n/* Overlay */\n.finalpricecard-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n/* Card Container */\n.finalpricecard-detail {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 1rem;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  position: relative;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Title */\n.finalpricecard-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  color: #333;\n}\n\n/* Info Section */\n.finalpricecard-info > div {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.8rem;\n  font-size: 1rem;\n  color: #555;\n}\n\n/* Close Button */\n.finalpricecard-close-btn {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #888;\n  transition: color 0.2s;\n}\n.finalpricecard-close-btn:hover {\n  color: #f00;\n}\n\n/* Buttons */\n.finalpricecard-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2rem;\n}\n.updatefinalPriceCard,\n.sendtosalesPricingDetail {\n  padding: 0.6rem 1.2rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  flex: 1;\n  margin: 0 0.5rem;\n  transition: background 0.3s ease;\n}\n.updatefinalPriceCard {\n  background-color: #007bff;\n  color: white;\n}\n.updatefinalPriceCard:hover {\n  background-color: #0056b3;\n}\n.sendtosalesPricingDetail {\n  background-color: #28a745;\n  color: white;\n}\n.sendtosalesPricingDetail:hover {\n  background-color: #1e7e34;\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive */\n@media screen and (max-width: 600px) {\n  .finalpricecard-detail {\n    padding: 1.5rem;\n  }\n\n  .finalpricecard-title {\n    font-size: 1.3rem;\n  }\n\n  .finalpricecard-info > div {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .finalpricecard-buttons {\n    flex-direction: column;\n  }\n\n  .updatefinalPriceCard,\n  .sendtosalesPricingDetail {\n    margin: 0.5rem 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
